<template>
    <Bank :id="Number(id)"/>
</template>
<script>
import Bank from '@/components/BankProduct.vue';

export default {
    components: {
        Bank
    },
    name: 'BankProductProfileView',
    data() {
        return {
            // Инициализация компонента Bank с id 0 для добавления нового банка
            id: this.$route.params.id || '0'
        }
    }
}
</script>